export const IMAGING_DATE_FILTER_API_URL='date-filter-source/NETWORKLEVER/';
export const IMAGING_TOP_FILTER_API_URL='standard-search/topfilter?items=';
export const IMAGING_CATEGORY_DETAILS_API_URL='network-measures-category-details/?request-type=RADIOLOGY';
export const IMAGING_NET_CATEGORY_DETAILS_API_URL='network-measures-category-details/?request-type=RADIOLOGY';
export const IMAGING_EXPORT_DETAILS_REQUEST_URL='network-measure-export-details?request-type=RADIOLOGY';
export const IMAGING_EXPORT_DETAILS_STATUS_URL='network-measure-export-status';
export const IMAGING_EXPOR_LINK_DETAILS_URL='network-measure-export-download-links';


